module.exports = __webpack_public_path__ + "img/logo-2.1db1e500.png";